import type { ColumnFiltersState, SortingState } from "@tanstack/vue-table";
import type { Ref, WritableComputedRef } from "vue";
import { useStorage } from "@vueuse/core";
import { computed, ref } from "vue";

export interface DataTableFilters {
  sorting: Ref<
    {
      id: string;
      desc: boolean;
    }[]
  >;
  columnFilters: Ref<
    {
      id: string;
      value: unknown;
    }[]
  >;
  rowSelection: Ref<{}>;
  globalFilter: Ref<string>;
  pagination: WritableComputedRef<{
    pageSize: number;
    pageIndex: number;
  }>;
}

export interface InitialFilter {
  id?: string;
  columnFilters?: ColumnFiltersState;
  sorting?: SortingState;
  rowSelection?: {};
  globalFilter?: string;
  pageSize?: number;
  pageIndex?: number;
}

export const useTableFilters = (options?: InitialFilter): DataTableFilters => {
  const pageSize = useStorage("table-page-size" + options?.id, options?.pageSize ?? 10);
  const pageIndex = ref(0);
  const sorting = ref<SortingState>(options?.sorting ?? []);
  const columnFilters = ref<ColumnFiltersState>(options?.columnFilters ?? []);
  const rowSelection = ref(options?.rowSelection ?? {});
  const globalFilter = ref(options?.globalFilter ?? "");

  const pagination = computed({
    get() {
      return {
        pageSize: pageSize.value,
        pageIndex: pageIndex.value,
      };
    },
    set(val) {
      pageSize.value = val.pageSize;
      pageIndex.value = val.pageIndex;
    },
  });

  return {
    sorting,
    columnFilters,
    rowSelection,
    globalFilter,
    pagination,
  };
};
